/* @flow */
import * as React from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

// Styles
import styles from './BraindateCardAuthor.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Hooks
import useSelf from 'src/shared/domain/user/hook/useSelf';
import { useMediaQuery } from '@mui/material';

// Utils
import messages from 'src/shared/app/braindate/l10n/braindateL10n';
import { phablet } from '@braindate/ui/lib/token/mediaQuery';
import { getUserTitle } from 'src/shared/app/user/util/userUtils';
import { isGroupTopic } from '@braindate/domain/lib/topic/util';
import { getBraindateTopic } from 'src/shared/domain/braindate/util/braindateUtil';
import { getUserPath, getUserFullName } from '@braindate/domain/lib/user/util';

// Components
import UserAvatar, {
  small,
  xsmall,
} from 'src/shared/components/domain/user/avatar/UserAvatar';

// Types
import type { Braindate } from '@braindate/domain/lib/braindate/type';
import type { ExpressionOfGratitude } from '@braindate/domain/lib/expressionOfGratitude/type';
import { getBraindateWith } from '../list/util/braindateUtils';

const useStyles = createUseThemeStyles(styles);

type Props = {
  braindate: Braindate,
  expressionOfGratitude?: ExpressionOfGratitude,
};

const BraindateCardAuthor = ({ braindate, expressionOfGratitude }: Props) => {
  const classes = useStyles();
  const intl = useIntl();
  const self = useSelf();
  const isPhablet = useMediaQuery(phablet);

  const topic = getBraindateTopic(braindate);
  const isGroupBraindate = isGroupTopic(topic);

  if (!self) return null;

  const braindateWith = getBraindateWith(
    self,
    braindate,
    expressionOfGratitude,
  );

  const userFullName = getUserFullName(braindateWith);

  return (
    <Link to={getUserPath(braindateWith)}>
      <div className={classes.root}>
        <UserAvatar user={braindateWith} variant={isPhablet ? small : xsmall} />

        <div className={classes.info}>
          <span className={classes.name}>
            {isGroupBraindate
              ? intl.formatMessage(messages.createdBy)
              : userFullName}
          </span>

          <span className={classes.title}>
            {isGroupBraindate && (
              <span className={classes.titleName}>{userFullName}</span>
            )}
            {!isGroupBraindate && getUserTitle(braindateWith, intl)}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default React.memo<Props>(BraindateCardAuthor);
